export default "__VITE_ASSET__DerW6iMG__";